import { Helmet } from 'react-helmet-async';
import { Container, FormControlLabel, Stack, Switch, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { getRewardConfig, updateRewardConfig } from '../services/Common/reward.service';

export default function RewardsPage() {
    const [form, setForm] = useState({ loginBonus: 10, clickWinReward: 10, quizReward: 5, loginEnabled: true, clickWinEnabled: true, spinEnabled: true, earningRates: {} });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getRewardConfig()
            .then((data) => setForm((current) => ({ ...current, ...data })))
            .catch(() => toast('Failed to load reward settings', { type: 'error' }));
    }, []);

    const save = async () => {
        try {
            setLoading(true);
            await updateRewardConfig(form);
            toast('Reward settings updated', { type: 'success' });
        } catch (_) {
            toast('Failed to update reward settings', { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Helmet><title>Daily Rewards | Trooper</title></Helmet>
            <Container>
                <Typography variant="h4" gutterBottom>Daily Rewards</Typography>
                <Stack spacing={3} sx={{ maxWidth: 560, mt: 3 }}>
                    <FormControlLabel control={<Switch checked={form.loginEnabled} onChange={(e) => setForm({ ...form, loginEnabled: e.target.checked })} />} label="Login bonus enabled" />
                    <TextField type="number" label="Login bonus (EV)" value={form.loginBonus} onChange={(e) => setForm({ ...form, loginBonus: Number(e.target.value) })} />
                    <FormControlLabel control={<Switch checked={form.clickWinEnabled} onChange={(e) => setForm({ ...form, clickWinEnabled: e.target.checked })} />} label="Click & Win enabled" />
                    <TextField type="number" label="Click & Win reward (EV)" value={form.clickWinReward} onChange={(e) => setForm({ ...form, clickWinReward: Number(e.target.value) })} />
                    <TextField type="number" label="Quiz reward (EV)" value={form.quizReward} onChange={(e) => setForm({ ...form, quizReward: Number(e.target.value) })} />
                    <FormControlLabel control={<Switch checked={form.spinEnabled} onChange={(e) => setForm({ ...form, spinEnabled: e.target.checked })} />} label="Spin Wheel enabled" />
                    <Typography variant="body2" color="text.secondary">Spin values use the existing EV wheel segments.</Typography>
                    <Typography variant="h6">Activity earning rates (EV)</Typography>
                    {[
                        ['game_moment', 'Game moment upload'],
                        ['content_view', 'Content view'],
                        ['viral_bonus', 'Viral bonus'],
                        ['engagement', 'Engagement'],
                        ['tournament_win', 'Tournament win'],
                    ].map(([key, label]) => (
                        <TextField
                            key={key}
                            type="number"
                            label={label}
                            value={form.earningRates?.[key] ?? 0}
                            onChange={(e) => setForm({ ...form, earningRates: { ...form.earningRates, [key]: Number(e.target.value) } })}
                        />
                    ))}
                    <LoadingButton variant="contained" size="large" loading={loading} onClick={save}>Save Reward Settings</LoadingButton>
                </Stack>
            </Container>
        </>
    );
}
